import "./richText";

import {getStringTemplates, getStrings} from "./strings";

import $ from "jquery";
import CanvasPlayer from "@rmlibrary/canvas-player";
import { Slider } from "@rmlibrary/slider";
import animation from "pacAnimation";
import {lang} from "./util";

const strings = getStrings(lang);
let pacCanvasPlayer;
let btnPlayPause;
let playStateToggled = false;
let canvasHeightOld = 0;
function init(storage) {
    const jarFontSize = 60;
    const chequeFontSize = 56;
    const phoneFontSize = 40;
    let sliderSeeking = false;
    let destroyed = false;
    // Setup string templates using richtext
    let stringTemplates = getStringTemplates(storage, lang); // TODO: Dynamic based on language
    let stageVars = {
        pacSavingsGoal: storage.pacSavingsGoal,
        pacSavingsGoalKey: storage.pacSavingsGoalKey,
        pacName: storage.pacName,
        pacBiWeeklyExtraSavings: storage.formattedOutput.pacBiWeeklyExtraSavings,
        pacMonthlyAmount: storage.formattedOutput.pacMonthlyAmount,
        pacMonthlySavingsTotal: storage.formattedOutput.pacMonthlySavings,
        pacMonthlySavingsAmount: `${storage.formattedOutput.pacMonthlyAmount} ${strings.monthly}`,
        pacBiWeeklySavingsTotal: storage.formattedOutput.pacBiWeeklySavings,
        pacBiWeeklySavingsAmount: storage.formattedOutput.pacBiWeeklyAmount,
        pacBiWeeklyDifference: storage.formattedOutput.pacBiWeeklyDifference,
        pacBiWeeklyExtraDifference: storage.formattedOutput.pacBiWeeklyExtraDifference,
        pacDate: storage.pacDate,
        jarTextSize: getTextSize(storage.pacName, {
            defaultFontSize: jarFontSize,
            fontWeight: "bold",
            textBoxWidth: 280
        }).font,
        jarTextHeight: getTextSize(storage.pacName, {
            defaultFontSize: jarFontSize,
            fontWeight: "bold",
            textBoxWidth: 280
        }).sizeDifference,
        chequeTextSize: getTextSize(storage.pacName, {
            defaultFontSize: chequeFontSize,
            fontWeight: "bold",
            textBoxWidth: 570
        }).font,
        chequeTextHeight: getTextSize(storage.pacName, {
            defaultFontSize: chequeFontSize,
            fontWeight: "bold",
            textBoxWidth: 570
        }).sizeDifference,
        phoneTextSize: getTextSize(stringTemplates["pacNameGoal"], {
            defaultFontSize: phoneFontSize,
            fontWeight: "bold",
            fontFamily: "Scotia Headline",
            textBoxWidth: 370
        }).font,
        phoneTextHeight: getTextSize(stringTemplates["pacNameGoal"], {
            defaultFontSize: phoneFontSize,
            fontWeight: "bold",
            fontFamily: "Scotia Headline",
            textBoxWidth: 370
        }).sizeDifference
    };
    Object.keys(stringTemplates).forEach((templateName) => {
        stageVars[templateName] = formatAnimateRichText(stringTemplates[templateName], templateName);
    });
    stageVars.goalClip = playGoalClip(stageVars.pacSavingsGoalKey);
    stageVars.spinnerClip = playSpinnerClip(stageVars.pacMonthlyAmount);
    if(stageVars.pacSavingsGoalKey === "anythingElse"){
        stageVars.pacMonthlySavingGoal = formatAnimateRichText(stringTemplates["pacMonthlySavingGoalAnything"], "pacMonthlySavingGoal");
        stageVars.pacDifferenceBiWeeklyExtra = formatAnimateRichText(stringTemplates["pacDifferenceBiWeeklyExtraAnything"], "pacDifferenceBiWeeklyExtra");
        stageVars.pacHelpGoal = formatAnimateRichText(stringTemplates["pacHelpGoalAnything"], "pacHelpGoal");
    }
    if(storage.pacName.length > 7){
        if (stageVars.pacSavingsGoalKey === "anythingElse"){
            stageVars.pacMonthlySavingGoal = formatAnimateRichText(stringTemplates["pacMonthlySavingGoalAnythingLongName"], "pacMonthlySavingGoal");
        }
        else{
            stageVars.pacMonthlySavingGoal = formatAnimateRichText(stringTemplates["pacMonthlySavingGoalLongName"], "pacMonthlySavingGoal");
        }
        if(lang === "en"){
            stageVars.pacAutomaticSavings = formatAnimateRichText(stringTemplates["pacAutomaticSavingsLongName"], "pacAutomaticSavings");
        }
    }

    const videoContainerElem = document.querySelector("#video-container");
    const loader = document.querySelector("#video-container .preload");
    const loaderTxt = videoContainerElem.querySelector(".preload #loadingTxt");
    const playBtn = document.querySelector("#video-container .play-btn");
    const replay = document.querySelector("#video-container .replay");
    const replayButton = document.querySelector("#video-container button");
    const controls = document.querySelector("#video-container .controls");
    btnPlayPause = document.querySelector("#video-container .controls .btn-play-pause");
    const btnCC = document.querySelector("#video-container .controls .btn-cc");
    const btnFullscreen = document.querySelector("#video-container .controls .btn-fullscreen");
    const txtCurrentTime = document.querySelector("#video-container .controls .time-indicator .current-time");
    const txtDuration = document.querySelector("#video-container .controls .time-indicator .duration");
    const loadingMeterBar = document.querySelector(".preload .loadingMeterBar");
    const closeBtn = document.querySelector("#video-container .close-screen");
    const sliderElem = document.querySelector("#video-container .rm-slider");
    const sliderWrapperElem = document.querySelector("#video-container .slider-wrapper");
    const pacCanvasPlayerOptions = {
        width: 1920,
        height: 1080,
        fonts: [""],
        autoplay: true,
        stageVars: stageVars,
        preloadImages: true,
        ccName: "",
        pixelDensity: Math.max(1, window.devicePixelRatio || 1),
        rootName: lang === "en" ? "Pacvideo" : "Pacvideo_fr",
        resizeEndHook: function () {
            const full = $(".controls");
            const left = full.find(".controls-left").first();
            const right = full.find(".controls-right").first();
            $(".slider-wrapper").width(full.outerWidth() - left.outerWidth() - right.outerWidth() - 30);
            /* const canvasHeight = document.querySelector(".canvas-player canvas").style.height;
            if (canvasHeightOld > 0 && canvasHeightOld < parseInt(canvasHeight.replace("px", ""))){
                document.querySelector(".canvas-player").style.height = "";
            }
            else{
                document.querySelector(".canvas-player").style.height = canvasHeight;
            }
            canvasHeightOld = parseInt(document.querySelector(".canvas-player").style.height.replace("px", ""));
            console.log(canvasHeightOld); */
            /* const cw = this.container.offsetWidth;
            const ch = this.container.offsetHeight;
            const factorW = cw / this._canvas.width;
            const factorH = ch / this._canvas.height;
            const factor = Math.min(factorW, factorH);
            const vw = factor * this._canvas.width;
            const vh = factor * this._canvas.height;
            const pixelDensity = this._pixelDensity || 1; */

            //document.querySelector(".canvas-player").style.height = this._canvas.style.height;
        }

    };
    pacCanvasPlayer = new CanvasPlayer(
        videoContainerElem,
        animation.lib,
        animation.images,
        //animation.soundPlayers,
        pacCanvasPlayerOptions
    );
    pacCanvasPlayer.on("loadstart", function () {
        playBtn.classList.add("hide");
        loader.classList.remove("hide");
        //closeBtn.classList.add("hide");
        destroyed = false;
    });
    pacCanvasPlayer.on("progress", function () {
        var p = pacCanvasPlayer.getProgress();
        var suffix = "%";
        loaderTxt.textContent = Math.round(p * 100) + suffix;
        $(loadingMeterBar).width(Math.round(p * 100) + "%");
    });
    pacCanvasPlayer.on("canplay", function () {
        loader.classList.add("hide");
        //playBtn.classList.remove("hide");
        //closeBtn.classList.remove("hide");
    });
    pacCanvasPlayer.on("timeupdate", function () {
        // if(pacCanvasPlayer.getCurrentTime() === pacCanvasPlayer.getDuration()-1){
        //     console.log(pacCanvasPlayer.getCurrentTime());
        // }
        if(pacCanvasPlayer.getCurrentTime() === pacCanvasPlayer.getDuration()){
            pacCanvasPlayer.togglePaused();
            if($(btnFullscreen).hasClass('fullscreen'))
                toggleFullscreen();
            $(".page-container #video-container").hide();
            $(".page-container .end-screen").show();
            
        }
        txtCurrentTime.textContent = formatTime(Math.round(pacCanvasPlayer.getCurrentTime()));
        if (!sliderSeeking) {
            slider.value = Math.min(slider.options.sections[1], (pacCanvasPlayer.getCurrentTime() / pacCanvasPlayer.getDuration()) * slider.options.sections[1]);
        }
    });
    pacCanvasPlayer.on("durationchange", function () {
        txtDuration.textContent = formatTime(pacCanvasPlayer.getDuration());
    });
    pacCanvasPlayer.on("play", function () {
        if (destroyed === true) {
            pacCanvasPlayer.destroy();
            destroyed = false;
        } else {
            btnPlayPause.classList.remove("paused");
        }
    });
    pacCanvasPlayer.on("pause", function () {
        btnPlayPause.classList.add("paused");
    });
    pacCanvasPlayer.on("ended", function () {
        //replay.classList.remove("hide");
        //btnPlayPause.classList.add("paused");
        //delete stageVars.doNotResize;
        $(".page-container #video-container").hide();
        $(".page-container .end-screen").show();
        
        if($(btnFullscreen).hasClass('fullscreen'))
            toggleFullscreen();
    });
    pacCanvasPlayer.on("fullscreenchange", function () {
        if (pacCanvasPlayer.isFullscreen()) btnFullscreen.classList.add("fullscreen");
        else btnFullscreen.classList.remove("fullscreen");
    });
    

    var hideControls = function () {
        controls.classList.remove("show-controls");
        videoContainerElem.classList.remove("show-cursor");
        closeBtn.classList.remove("show-controls");
    };

    var showControls = function () {
        controls.classList.add("show-controls");
        videoContainerElem.classList.add("show-cursor");
        closeBtn.classList.add("show-controls");
    };

    var mouseTimeout = setTimeout(hideControls, 3000);

    var mouseMoveListener = function () {
        showControls();
        clearTimeout(mouseTimeout);
        mouseTimeout = setTimeout(hideControls, 3000);
    };

    var mouseUpListener = function () {
        videoContainerElem.addEventListener("mousemove", mouseMoveListener);
        clearTimeout(mouseTimeout);
        mouseTimeout = setTimeout(hideControls, 3000);
    };

    var mouseDownListener = function () {
        clearTimeout(mouseTimeout);
        showControls();
        videoContainerElem.removeEventListener("mousemove", mouseMoveListener);
        videoContainerElem.removeEventListener("mouseup", mouseUpListener);
        videoContainerElem.addEventListener("mouseup", mouseUpListener);
    };

    var touchStartListener = function () {
        clearTimeout(mouseTimeout);
        showControls();
        videoContainerElem.removeEventListener("mousemove", mouseMoveListener);
        videoContainerElem.removeEventListener("touchend", mouseUpListener);
        videoContainerElem.addEventListener("touchend", mouseUpListener);
    };

    var togglePlay = () => {
        replay.classList.add("hide");
        playBtn.classList.add("hide");
        pacCanvasPlayer.togglePaused();
    };
    btnPlayPause.addEventListener("mousedown", togglePlay);

    videoContainerElem.addEventListener("mousemove", mouseMoveListener);

    videoContainerElem.addEventListener("mousedown", mouseDownListener);

    videoContainerElem.addEventListener("touchstart", touchStartListener);

    const slider = new Slider(sliderElem, {
        min: 0,
        max: 1000,
        step: 1
    });

    slider.on("down", function () {
        sliderSeeking = true;
        replay.classList.add("hide");
        if (!pacCanvasPlayer._paused) {
            playStateToggled = true;
            pacCanvasPlayer.togglePaused();
        }
    });

    slider.on("change", function (val) {
        var duration = pacCanvasPlayer.getDuration();
        txtCurrentTime.textContent = formatTime(
            Math.round((val / 1000) * duration)
        );
    });

    slider.on("up", function (val) {
        sliderSeeking = false;
        var frame = (val / slider.options.sections[1]) * pacCanvasPlayer.getTotalFrames();
        pacCanvasPlayer.goToFrame(frame);
        if (playStateToggled) {
            playStateToggled = false;
            pacCanvasPlayer.togglePaused();
        }
    });

    var toggleFullscreen = function () {
        pacCanvasPlayer.toggleFullscreen();
    };

    btnFullscreen.addEventListener("mouseup", toggleFullscreen);
    btnFullscreen.addEventListener("touchstart", toggleFullscreen);

    function restartPlay() {
        replay.classList.add("hide");
        playBtn.classList.add("hide");
        btnPlayPause.classList.remove("paused");
        pacCanvasPlayer.goToFrame(0);
        if (pacCanvasPlayer._paused) {
            pacCanvasPlayer.togglePaused();
        }
    }
    if (replayButton) {
        replayButton.addEventListener("mousedown", restartPlay);
        replayButton.addEventListener("touchstart", restartPlay);
    }
}

function formatTime(s) {
    var seconds = (s % 60) + "",
        minutes = Math.floor(s / 60) + "";

    if (seconds.length === 1) seconds = "0" + seconds;

    return minutes + ":" + seconds;
}

function formatAnimateRichText(text, variableName) {
    return (player) => {
        if (text.includes("</b>") || text.includes("</i>")) {
            Object.setPrototypeOf(player[variableName], createjs.RichText.prototype);
            player[variableName]._baseFont = player[variableName].font;
            player[variableName]._color = player[variableName].color;
            player[variableName].markup = text;
        } else {
            player[variableName].text = text;
        }
    };
}

function playGoalClip(goal){
    return (player) => {
        const savingsGoalDict = {
            "downPayment": "goal_down_payment",
            "wedding": "goal_wedding",
            "homeRenovations": "goal_home_renovations",
            "personalSplurge": "goal_personal_splurge",
            "emergencyFund": "goal_emergency",
            "dreamVacation": "goal_dream_vacation",
            "car": "goal_car",
            "school": "goal_school",
            "anythingElse": "goal_anything"
        };
        player.gotoAndStop(savingsGoalDict[goal]);
    };
}

// dynamically calculates font size so that text fits in canvas text boxes
function getTextSize(text, opts) {
    let c;
    let font;
    let size;
    let sizeDifference;

    opts.textBoxWidth = opts.textBoxWidth || 320;
    opts.defaultFontSize = opts.defaultFontSize || 67;
    opts.fontFamily = opts.fontFamily || "Scotia";
    opts.fontWeight = opts.fontWeight || "";

    c = $("<canvas></canvas>")[0].getContext("2d");
    c.font = opts.fontWeight + " " + opts.defaultFontSize + "px " + opts.fontFamily;

    size = c.measureText(text).width;
    if (size > opts.textBoxWidth) {
        size = Math.floor(opts.defaultFontSize / (size / opts.textBoxWidth));
        font = opts.fontWeight + " " + size + "px '" + opts.fontFamily + "'";
        sizeDifference = opts.defaultFontSize - size;
    }
    else {
        font = opts.fontWeight + " " + opts.defaultFontSize + "px '" + opts.fontFamily + "'";
        sizeDifference = 0;
    }
    return {
        font: font,
        sizeDifference: sizeDifference
    };
}

function playSpinnerClip(amount){
    return (player) => {
        const spinnerIDs = [0, 1, 2, 3, 4, 5, 6];
        const spinnerFrameDict = {
            "$": 10,
            "0": 20,
            "1": 30,
            "2": 40,
            "3": 50,
            "4": 60,
            "5": 70,
            "6": 80,
            "7": 90,
            "8": 100,
            "9": 110,
        };
        const amountChars = amount.replace(/[,\s]/ig, "").split("");
        const currentIndex = parseInt(player.name.charAt(player.name.length-1)) - 1;
        const charDiff = spinnerIDs.length - amountChars.length;
        if(currentIndex >= charDiff){
            const requiredIDs = spinnerIDs.slice(charDiff);
            const clipIndex = requiredIDs.indexOf(currentIndex);
            const clipLabel = amountChars[clipIndex];
            player.paused = false;
            player.gotoAndStop(spinnerFrameDict[clipLabel]);
        }
    };
}

function replayVideo(storage){
    btnPlayPause.classList.remove("paused");
    pacCanvasPlayer.destroy();
    init(storage);
    //pacCanvasPlayer.goToFrame(0);
    /* if (pacCanvasPlayer._paused) {
        pacCanvasPlayer.togglePaused();
    } */
}

export{
    init as initVideo,
    replayVideo
};